import type { FaireProductEntity } from "../../entity_types/product";

export const p_ncr9uruq8p: FaireProductEntity = {
  token: "p_ncr9uruq8p",
  type: "product",
  name: "Goodnight Moon Board Book & Bunny: Margaret Wise Brown",
  brandToken: "b_brkasb91",
  brandName: "HarperCollins",
  imageUrl:
    "https://cdn.faire.com/fastly/7e5090408c24ac4f1a491ecba446636459aa167967f4a1f43e57bf28b97d871c.jpeg",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    "An Easter And Springtime Book For Kids\nBoard Book \n\nGenerations of children have been lulled to sleep with this classic bedtime story. Now kids can enjoy the gentle rhythm of Goodnight Moon while snuggling up to this darling plush bunny. The quiet poetry of the words combined with an extra soft toy make for a perfect gift…and a peaceful sleep.",
  tags: [],
  msrpDollars: 21.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:27.640Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
